export default __webpack_public_path__ + "static/media/addmedia-empty-img.5f656b95.png";